import { render } from "./VideoPlayer.vue?vue&type=template&id=30feafc6"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=30feafc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__